import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { Toast } from "primereact/toast";
import { Route, Routes, useLocation } from "react-router-dom";
import qs from "qs";
import UrlHelper from "js-url-helper";
import AlpAvisoOutboundGroupList from "./partials/AlpAvisoOutboundGroupList";

const url = new UrlHelper();

const AlpAvisoOutboundGroups = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const { state } = useLocation();

    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        filters: []
    });

    useEffect(() => {
        document.title = t("outbound load groups");

        const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
        setModuleState({
            page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
            per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
            search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
            initialized: true,
        });
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <AlpAvisoOutboundGroupList
                                    moduleState={ moduleState }
                                    toastify={ toastify }
                                    setQuery={ setModuleState }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

export default withTranslation()(AlpAvisoOutboundGroups);

